import { Directive, Input, Component, ElementRef } from '@angular/core';
import { TranslateService } from 'app/core/services/translate.service';

declare var $: any;

@Directive({
  selector: '[itpxSolarTooltip]'
})
export class SolarTooltipDirective {
  @Input('tooltip-key') key: string;
  @Input('tooltip-text') text: string;
  @Input('tooltip-placement') placement: string = 'bottom';
  @Input('tooltip-enable-html') enableHtml = true;
  @Input('tooltip-component') component: Component;

  constructor(private el: ElementRef,
      private translateService: TranslateService
  ) {
  }

  ngOnInit() {

      this.el.nativeElement.setAttribute('data-container', 'body');
      this.el.nativeElement.setAttribute('data-trigger', 'hover');
      this.el.nativeElement.setAttribute('data-toggle', 'popover');
      this.el.nativeElement.setAttribute('data-placement', `auto ${this.placement}`);
      this.el.nativeElement.setAttribute('data-content', this.translateService.translate(this.text));
      // this.el.nativeElement.setAttribute('data-content', '<itpx-dynamic-grid></itpx-dynamic-grid>');
      if (this.enableHtml) {
          this.el.nativeElement.setAttribute('data-html', this.enableHtml);
      }

      $(this.el.nativeElement).popover();
  }

  ngOnDestroy() {

      $(this.el.nativeElement).popover('hide');
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/directives/solar-tooltip.directive.ts